import React, { createContext, useContext, useRef } from "react";

// Create Scroll Context
const ScrollContext = createContext();

// Custom hook to access ScrollContext
export const useScroll = () => useContext(ScrollContext);

// Scroll Provider Component
export const ScrollProvider = ({ children }) => {
    // Store references for sections dynamically
    const sectionRefs = useRef({});

    // Function to register section dynamically
    const registerSection = (sectionKey) => {
        if (!sectionRefs.current[sectionKey]) {
            sectionRefs.current[sectionKey] = React.createRef();
        }
    };

    // Function to scroll to section
    const scrollToSection = (sectionKey) => {
        const section = sectionRefs.current[sectionKey]?.current;
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <ScrollContext.Provider value={{ sectionRefs, registerSection, scrollToSection }}>
            {children}
        </ScrollContext.Provider>
    );
};
